export default __webpack_public_path__ + "static/media/document.b6badd4b.svg";